import Constant from '@/const';
import axios from 'axios';

const getProcedureById = async id => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/master/procedure/${id}`),
    );
    return response.data.data;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default getProcedureById;
